import * as React from "react";
import {useState, useContext, useEffect} from "react";
import { useNavigate, useLocation } from "react-router";
import { useSearchParams, useParams } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext.component";
import logo from "../../../assets/logo.svg";
import "./style.scss";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, Input, useFocusEffect } from "@chakra-ui/react";

export function SignInFormQuote() {
    const [id, setId] = useState<string>("");
    const [postcode, setPostcode] = useState<string>("");
    const [isError, setIsError] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    let { quoteId } = useParams();

    const authContext = useAuth();
    const [searchParams, setSearchParams] = useSearchParams();
    let navigate = useNavigate();
    let location = useLocation();

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsError(false);
        setIsLoading(true);

        console.log(`handleSubmit: ${id} ${postcode}`)
        authContext.signInQuote(id, postcode.replace(/\s+/g, "")).then(result => {
            if (result) {
                let returnUrl = searchParams.get("returnUrl");
            
                if (returnUrl != null) {
                    console.log(decodeURIComponent(returnUrl));
                    navigate(decodeURIComponent(returnUrl));
                }
                else {
                    navigate("/quote/overview/" + id);
                }
            } else {
                setIsLoading(false);
                setIsError(true);
            }
        });
    }

    useEffect(() => {
        if (quoteId) { 
            setId(quoteId);
            console.log(quoteId);
        };
    }, []);

    return (
        <>
            <div className="sign-in-form">
                <div className="sign-in-form--left-panel">
                    <div className="sign-in-form--text">
                        <div className="sign-in-form--text-top">
                            <img className="logo" src={logo} alt="Able Group"/>
                        </div>
                        <div className="sign-in-form--text-bottom">
                            <h3 className="sign-in-form--subheading">Welcome!</h3>
                            <p className="sign-in-form--paragraph">Please login to view your quote and to book an appointment.</p>
                        </div>
                    </div>
                </div>

                <form className={'sign-in-form--right-panel'} onSubmit={handleSubmit}>
                    <div className="form-inputs">
                        <div className="form-input-container">
                            <input onChange={(e) => setId(e.target.value)} placeholder="Quote Reference" type="text" value={id.toUpperCase()} className="form-input"/>
                        </div>
                        <div className="form-input-container">
                            <input onChange={(e) => setPostcode(e.target.value)} placeholder="Postcode" type="text" value={postcode.toUpperCase()} className="form-input"/>
                        </div>
                        {isError &&
                        <Alert status='error' borderRadius={5}>
                            <AlertIcon/>
                            <Box>
                                <AlertTitle>Login failed.</AlertTitle>
                                <AlertDescription>Check the details you entered are correct.</AlertDescription>
                            </Box>
                        </Alert>
                    }
                    </div>
                    <Button mt={4} bg='var(--Able-blue)' color='white' size='lg' fontSize='xl' width={175} borderRadius={15}
                        isLoading={isLoading} loadingText='Log In' spinnerPlacement="end" type='submit'>Log In</Button>
                </form>
            </div>
        </>
    );
}